/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';
import { IAssetsSlice } from './types';

const initialState: IAssetsSlice = {
	items: []
};

const assetsSlice = createSlice({
	name: 'assets',
	initialState,
	reducers: {
		addAssets: (state, action) => {
			const nextItems = action.payload as IAssetsSlice['items'];
			nextItems.forEach((asset) => {
				const exists = state.items.some((item) => item.id === asset.id);
				if (!exists) {
					state.items.push(asset);
				}
			});
		},
		removeAssetsByIds: (state, action) => {
			const ids = action.payload as number[];
			state.items = state.items.filter((item) => !ids.includes(item.id));
		},
		removeAssetsByRoute: (state, action) => {
			state.items = state.items.filter((item) => item.route !== action.payload);
		}
	}
});

export const assetsReducer = assetsSlice.reducer;
export const assetsActions = assetsSlice.actions;
